import { render, staticRenderFns } from "./clientuser.vue?vue&type=template&id=6c68e799&scoped=true&"
import script from "./clientuser.vue?vue&type=script&lang=js&"
export * from "./clientuser.vue?vue&type=script&lang=js&"
import style0 from "./clientuser.vue?vue&type=style&index=0&id=6c68e799&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c68e799",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VDataTable,VIcon})
